<template>
    <modal
        v-if="signature"

        ref="modal_signature"

        :title="userComputed?.full_name ?? 'Operative'"
        :subtitle="signature.created_at_formatted"
        :close_on_focus="true"
        :left_title="true"
    >
        <img :src="signature.url" :alt="`${userComputed?.full_name}'s signature`" class="img-fluid">
    </modal>
</template>

<script>
	import Modal from "../general_components/Modal";
	export default {
		name: "ShowSignatureModal",
		components: {Modal},
		props: [
        	'signature',
            'user'
        ],

        methods: {
			open(){
				this.$nextTick(function (){
					this.$refs.modal_signature.openModal();
                })
            }
        },

        computed: {
            userComputed: function(){
                return this.user ?? this.signature?.user ?? {}
            }
        }
	}
</script>
